module.exports = __webpack_public_path__ + "img/menu-divider-dark.b09f30d.svg";